import { useMemoizedFn } from 'ahooks';
import { submitAnswer } from '@/api/writing';
import TopBar from '../TopBar';
import { useExamSubmission } from '../../useExamSubmission';

interface Props {
  recordId: number;
}

const noop = () => undefined;

export default function PendingWritingSubmission({recordId}: Props) {
  const submit = useMemoizedFn(async (signal: AbortSignal) => (
    await submitAnswer({record_id: recordId}, {signal})
  ).data);
  const {submitHandle} = useExamSubmission({
    recordId,
    course: 'writing',
    ready: true,
    expired: true,
    submit,
  });

  return <TopBar
    time={0}
    isAI={false}
    isSubject={false}
    tabSubjectHandle={noop}
    isListen={false}
    loadAnswered
    updateTimeHandle={noop}
    submitHandle={submitHandle}
    noteHandle={noop}
    audioSrc=""
    course="w"
  />;
}
